export function getEuroCurrency(value: number | string): string {
  if (typeof value === 'string') {
    value = parseFloat(value);
  }
  return value.toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
    useGrouping: true,
    minimumFractionDigits: 0,
  });
}
